<h2 class="appointment-form-title">
  <T
  str="Choose vehicle"
  key="customerPortal.customer-portal.appointments.choose-vehicle"
  tags="customer-portal, 3.1"
></T>
</h2>

<customer-portal-vehicle-picker
  [vehicles]="appointmentsPopupService.vehicles"
  [brands]="appointmentsPopupService.brands"
  [loading]="appointmentsPopupService.loading"
  [country]="appointmentsPopupService.country"
  [showOtherOption]="true"
  [cantons]="cantons"
  [carsControl]="appointmentsPopupService.firstFormGroup.controls.cars"
  [makeControl]="appointmentsPopupService.make"
  [modelControl]="appointmentsPopupService.model"
  [licencePlateDE]="appointmentsPopupService.licencePlateDE"
  [licencePlateCH]="appointmentsPopupService.licencePlateCH"
  [licencePlateCanton]="appointmentsPopupService.licencePlateCanton"
  [filteredOptions]="filteredOptions"
  [filteredOptionsModels]="filteredOptionsModels"
  [matcher]="matcher"
  (vehicleSelected)="appointmentsPopupService.selectedCar($event)"
  (otherVehicleSelected)="selectedOther()"
  (brandSelected)="getModelsDealers($event)">
</customer-portal-vehicle-picker>

<form
  class="first-form-group appointment-form"
  [formGroup]="appointmentsPopupService.firstFormGroup"
  >
  <div class="flex flex-col gap-[10px] md:hidden">
    <mat-divider class="my-4"></mat-divider>
    @if (!appointmentsPopupService.loading) {
      <button
        class="next revolution w-full md:w-auto"
        mat-button
        mat-flat-button
        color="secondary"
        type="button"
      [disabled]="
        !appointmentsPopupService.car ||
        appointmentsPopupService.otherVehicleFormIsInvalid() ||
        appointmentsPopupService.loadingCarData
      "
      (click)="
        appointmentsPopupService.showChooseStepDialog
          ? appointmentsPopupService.decideNextStep(stepper)
          : stepper.next();
        appointmentsPopupService.checkSelected()
      "
        >
        @if (appointmentsPopupService.loadingCarData) {
          <mat-spinner
            class="inline-block mr-2.5"
            [diameter]="16"
          ></mat-spinner>
        }
        {{ 'next' | sharedTranslate }}
      </button>
    }
  </div>
</form>

<ng-template #errorTranslation let-data="data">
  {{
  transifexService.getErrorTranslation(
  data,
  'customerPortal.customer-portal.appointment.error.',
  {
  errKey: {
  pattern: 'only-numbers-letters-allowed',
  maxlength: 'maximum-length-exceeded'
}
}
)
}}
</ng-template>

<ng-template #errorCHTranslation let-data="data" let-maxlength="maxlength">
  {{
  transifexService.getErrorTranslation(
  data,
  'customerPortal.customer-portal.appointment.ch.error.',
  {
  num: maxlength,
  errKey: {
  pattern: 'only-numbers-allowed',
  maxlength: 'max-length-characters'
}
}
)
}}
</ng-template>
